// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.Field__Component a[data-v-03f43b4c] {\n    text-decoration: underline;\n    color: #0091ae !important;\n    /* text-align: center; */\n    /* display: block; */\n}\n", ""]);
// Exports
module.exports = exports;
